import toast from 'react-hot-toast';

import { getDisplayError } from '../../../utils/get-display-error';
import { ConfirmDialog } from '../../../components/dialog/ConfirmDialog';
import { sendDieselSurchargeNewsletter } from '../models';
import { useAllGeneralSettings } from '../all-settings-context';
import { formatDateTime } from '../../../utils/date';
import { captureException } from '@sentry/react';

export const GeneralActionsPage = () => {
  const { settings } = useAllGeneralSettings();

  return (
    <div>
      <ConfirmDialog
        triggerText="Verzend diesel toeslag nieuwsbrief"
        triggerColor="secondary"
        title="Verzend diesel toeslag nieuwsbrief"
        submitText="Verzend"
        description={`Ben je zeker dat je de diesel toeslag nieuwsbrief wilt verzenden? Laatste verzonden op ${
          settings.dieselSurchargeEmailSentAt ? formatDateTime(settings.dieselSurchargeEmailSentAt) : 'n/a'
        }`}
        onSubmit={async () => {
          try {
            await sendDieselSurchargeNewsletter();
            toast.success('Diesel toeslag nieuwsbrief verzonden!');
          } catch (err: any) {
            captureException(err);
            toast.error('Kon diesel toeslag nieuwsbrief niet versturen: ' + getDisplayError(err));
            throw err;
          }
        }}
      />
    </div>
  );
};
